angular.module('akimboApp.cardData', [])

.constant('CARDS', {
	'4': 'light',
	'132': 'dark',
	'133': 'light',
	'150': 'light',
	'151': 'dark',
	'154': 'dark',
	'159': 'dark',
	'160': 'dark',
	'161': 'light',
	'162': 'dark',
	'163': 'dark',
	'165': 'dark',
	'170': 'dark',
	'173': 'dark',
	'174': 'dark',
	'175': 'dark',
	'176': 'dark',
	'178': 'dark',
	'179': 'light',
	'180': 'dark',
	'182': 'dark',
	'183': 'dark',
	'184': 'light',
	'185': 'light',
	'186': 'dark',
	'187': 'dark',
	'188': 'dark',
	'191': 'dark',
	'193': 'dark',
	'194': 'dark',
	'195': 'dark',
	'196': 'dark',
	'197': 'dark',
	'198': 'dark',
	'199': 'dark',
	'200': 'dark',
	'201': 'dark',
	'202': 'dark',
	'203': 'dark',
	'204': 'dark',
	'205': 'dark',
	'206': 'dark',
	'207': 'dark',
	'208': 'dark',
	'209': 'dark',
	'210': 'dark',
	'211': 'dark',
	'212': 'dark',
	'213': 'dark',
	'214': 'dark',
	'215': 'dark',
	'216': 'dark',
	'217': 'dark',
	'218': 'dark',
	'219': 'dark',
	'220': 'dark',
	'221': 'dark',
	'222': 'dark',
	'223': 'dark',
	'224': 'dark',
	'225': 'dark',
	'226': 'dark',
	'228': 'dark',
	'229': 'dark',
	'230': 'dark',
	'231': 'dark',
	'232': 'dark',
	'233': 'dark',
	'234': 'dark',
	'235': 'dark',
	'236': 'dark',
	'237': 'dark',
	'238': 'dark',
	'239': 'dark',
	'240': 'dark',
	'241': 'dark',
	'242': 'dark',
	'243': 'dark',
	'244': 'dark',
	'245': 'dark',
	'246': 'dark',
	'247': 'dark',
	'248': 'dark',
	'249': 'dark',
	'250': 'dark',
	'251': 'dark',
	'252': 'dark',
	'253': 'dark',
	'254': 'dark',
	'257': 'dark',
	'258': 'dark',
	'260': 'dark',
	'261': 'dark',
	'262': 'dark',
	'264': 'dark',
	'265': 'dark',
	'266': 'dark',
	'271': 'dark',
	'272': 'dark',
	'276': 'dark',
	'277': 'dark',
	'278': 'dark',
	'279': 'dark',
	'280': 'dark',
	'281': 'dark',
	'282': 'dark',
	'283': 'dark',
	'284': 'dark',
	'285': 'dark',
	'286': 'dark',
	'287': 'dark',
	'288': 'dark',
	'289': 'dark',
	'290': 'dark',
	'291': 'dark',
	'292': 'dark',
	'293': 'dark',
	'294': 'dark',
	'295': 'dark',
	'296': 'dark',
	'297': 'dark',
	'298': 'dark',
	'299': 'dark',
	'300': 'dark',
	'301': 'dark',
	'302': 'dark',
	'303': 'dark',
	'304': 'dark',
	'305': 'dark',
	'306': 'dark',
	'307': 'dark',
	'308': 'dark',
	'309': 'dark',
	'310': 'dark',
	'311': 'dark',
	'314': 'light',
	'318': 'dark',
	'319': 'dark',
	'324': 'dark',
	'325': 'dark',
	'326': 'dark',
	'328': 'light',
	'329': 'dark',
	'330': 'dark',
	'331': 'dark',
	'332': 'dark',
	'333': 'dark',
	'334': 'dark',
	'336': 'dark',
	'338': 'light',
	'339': 'dark',
	'340': 'dark',
	'341': 'dark',
	'346': 'dark',
	'347': 'dark',
	'348': 'dark',
	'349': 'dark',
	'350': 'dark',
	'351': 'light',
	'352': 'light',
	'353': 'dark',
	'354': 'dark',
	'357': 'dark',
	'358': 'light',
	'359': 'dark',
	'360': 'dark',
	'361': 'dark',
	'362': 'dark',
	'363': 'dark',
	'364': 'dark',
	'365': 'dark',
	'366': 'dark',
	'367': 'dark',
	'368': 'dark',
	'369': 'dark',
	'370': 'dark',
	'371': 'dark',
	'372': 'dark',
	'373': 'dark',
	'375': 'dark',
	'376': 'dark',
	'377': 'dark',
	'378': 'dark',
	'380': 'dark',
	'381': 'dark',
	'383': 'dark',
	'389': 'dark',
	'390': 'dark',
	'391': 'dark',
	'392': 'dark',
	'393': 'dark',
	'397': 'light',
	'398': 'light',
	'399': 'dark',
	'401': 'dark',
	'402': 'light',
	'412': 'dark',
	'413': 'light',
	'414': 'dark',
	'415': 'dark',
	'422': 'dark',
	'430': 'light',
	'432': 'dark',
	'433': 'dark',
	'434': 'dark',
	'435': 'dark',
	'440': 'light',
	'443': 'dark',
	'445': 'dark',
	'448': 'dark',
	'449': 'dark',
	'450': 'light',
	'453': 'light',
	'900': 'dark',
	'903': 'dark',
	'916': 'light',
	'1000': 'dark',
	'1115': 'light',
	'1133': 'light',
	'1174': 'dark',
	'1194': 'dark',
	'1195': 'dark',
	'1196': 'dark',
	'1198': 'dark',
	'1199': 'dark',
	'1200': 'light',
	'1215': 'dark',
	'1220': 'dark',
	'1255': 'dark',
	'1300': 'dark',
	'1305': 'dark',
	'1308': 'dark',
	'1309': 'dark',
	'1314': 'light',
	'1328': 'light',
	'1332': 'dark',
	'1334': 'dark',
	'1336': 'dark',
	'1338': 'light',
	'1339': 'dark',
	'1340': 'dark',
	'1341': 'dark',
	'1351': 'light',
	'1352': 'light',
	'1353': 'dark',
	'1362': 'dark',
	'1363': 'dark',
	'1364': 'dark',
	'1365': 'dark',
	'1366': 'dark',
	'1367': 'dark',
	'1368': 'dark',
	'1369': 'dark',
	'1370': 'dark',
	'1371': 'dark',
	'1372': 'dark',
	'1373': 'dark',
	'1375': 'dark',
	'1376': 'dark',
	'1377': 'dark',
	'1378': 'dark',
	'1380': 'dark',
	'1381': 'dark',
	'1383': 'dark',
	'1389': 'dark',
	'1390': 'dark',
	'1391': 'dark',
	'1392': 'dark',
	'1402': 'light',
	'1412': 'dark',
	'1414': 'dark',
	'1415': 'dark',
	'1443': 'dark',
	'1445': 'dark',
	'1850': 'light',
	'1916': 'dark',
	'2000': 'dark',
	'2100': 'dark',
	'2101': 'dark',
	'2102': 'dark',
	'2103': 'dark',
	'2104': 'dark',
	'2105': 'dark',
	'2106': 'dark',
	'2107': 'dark',
	'2109': 'dark',
	'2110': 'dark',
	'2111': 'dark',
	'2114': 'dark',
	'2127': 'dark',
	'2128': 'dark',
	'2129': 'light',
	'2132': 'light',
	'2134': 'light',
	'2135': 'dark',
	'2141': 'dark',
	'2142': 'dark',
	'2143': 'dark',
	'2150': 'light',
	'2151': 'dark',
	'2152': 'dark',
	'2153': 'dark',
	'2160': 'light',
	'2161': 'dark',
	'2163': 'dark',
	'2164': 'dark',
	'2165': 'dark',
	'2168': 'dark',
	'2200': 'dark',
	'2201': 'dark',
	'2204': 'dark',
	'2205': 'dark',
	'2208': 'dark',
	'2211': 'dark',
	'2212': 'dark',
	'2213': 'dark',
	'2235': 'dark',
	'2236': 'dark',
	'2239': 'dark',
	'2240': 'dark',
	'2241': 'dark',
	'2242': 'dark',
	'2243': 'dark',
	'2245': 'light',
	'2246': 'dark',
	'2247': 'dark',
	'2248': 'dark',
	'2250': 'dark',
	'2253': 'dark',
	'2254': 'dark',
	'2257': 'dark',
	'2259': 'light',
	'2261': 'dark',
	'2262': 'dark',
	'2263': 'dark',
	'2264': 'dark',
	'2265': 'dark',
	'2273': 'light',
	'2274': 'dark',
	'2275': 'dark',
	'2276': 'dark',
	'2277': 'dark',
	'2278': 'dark',
	'2280': 'dark',
	'2281': 'dark',
	'2285': 'dark',
	'2286': 'dark',
	'2289': 'light',
	'2290': 'dark',
	'2298': 'dark',
	'2299': 'dark',
	'2300': 'dark',
	'2301': 'dark',
	'2302': 'dark',
	'2303': 'dark',
	'2304': 'dark',
	'2306': 'dark',
	'2307': 'dark',
	'2308': 'dark',
	'2324': 'dark',
	'2327': 'dark',
	'2328': 'dark',
	'2329': 'dark',
	'2330': 'dark',
	'2332': 'dark',
	'2335': 'dark',
	'2336': 'dark',
	'2337': 'dark',
	'2338': 'dark',
	'2339': 'dark',
	'2340': 'dark',
	'2341': 'dark',
	'2342': 'dark',
	'2343': 'dark',
	'2344': 'dark',
	'2345': 'dark',
	'2346': 'dark',
	'2347': 'dark',
	'2348': 'dark',
	'2349': 'dark',
	'2350': 'dark',
	'2351': 'dark',
	'2352': 'dark',
	'2353': 'dark',
	'2355': 'dark',
	'2359': 'dark',
	'2362': 'dark',
	'2365': 'dark',
	'2367': 'dark',
	'2372': 'dark',
	'2373': 'dark',
	'2374': 'dark',
	'2376': 'dark',
	'2381': 'dark',
	'2385': 'dark',
	'2388': 'dark',
	'2393': 'dark',
	'2395': 'dark',
	'2397': 'dark',
	'3108': 'light',
	'9999': 'dark',
	'10000': 'dark',
	'10001': 'dark',
	'10448': 'dark',
	'90001': 'light',
	'90002': 'dark',
	'90003': 'dark',
	'90004': 'dark',
	'90005': 'light',
	'90006': 'light',
	'90007': 'light',
	'92208': 'light',
})

;